var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meaning-con"},[(_vm.currentItem?.illustration_url)?_c('img',{staticClass:"meaning-img",attrs:{"src":_vm.currentItem?.illustration_url,"alt":"","id":_vm.currentItem.id}}):_vm._e(),_c('p',{staticClass:"meaning-text"},[_vm._v(_vm._s(_vm.currentItem?.translation))])])
}
var staticRenderFns = []

export { render, staticRenderFns }